import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../utils/contants";

export const NoDataStateStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  .no-data-state {
    border-radius: 4px;
    border: 1px solid var(--flow-30-neutral-2, #dedafb);
    background: var(--flow-30-neutral-white, #fff);
    .templateHeading {
      display: flex;
      width: 500px;
      height: 57px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-self: stretch;
      background-color: #efedfd;
      padding: 16px;
      h4 {
        margin: 0;
      }
    }
  }

  .options {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }
`;
